import React, { Component } from 'react';
import classNames from 'classnames';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker } from '../Common/datePicker';
import { DisabledInputField } from '../Common/inputField';
import PriceFormatter from '../Common/priceFormatter';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import { ROOT_URL, companyCodeTitle, isVAK } from '../../actions/root_url';
import checkPermission from '../Common/permissions';

momentLocalizer(moment);

const getBsStyle = (input, value) => {
  return input === value ? 'success':'primary'
};

class RowRenderer extends Component {


    render() {
        //here we are just changing the style
        //but we could replace this with anything we liked, cards, images, etc
        //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
        return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }} ><ReactDataGrid.Row ref='row' {...this.props} /></div>);
    }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func
};

const renderVendorTypeRadios = props => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.error }, 'col-xs-4');
  return (
    <ButtonToolbar className='long-radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, 'All')}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='All' checked={props.input.value === 'All'}/>
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Active')}>
        <div className='radio'>
          <label for='active-radio-filter'>
            <input {...props.input} id='active-radio-filter' type='radio' name='statusFilterRadios' value='Active' checked={props.input.value === 'Active'}/>
            <Translate value="active" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Inactive')}>
        <div className='radio'>
          <label for='inactive-radio-filter'>
            <input {...props.input} id='inactive-radio-filter' type='radio' name='statusFilterRadios' value='Inactive' checked={props.input.value === 'Inactive'}/>
            <Translate value="inactive" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  )
}


class VendorStatementMain extends Component {
  static contextTypes = {
      router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.vendorsPage,
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,

        amount00_30: 0,
        amount31_60: 0,
        amount61_90: 0,
        amount_91: 0,
        current: 0,
        grand_amount: 0,
        Days: '',
    };
    this.handleResize = this.handleResize.bind(this);
    //this.fetchCustomerStatementList = this.fetchCustomerStatementList.bind(this);
    this.fetchVendorStatementList = this.fetchVendorStatementList.bind(this);
    this.statementDetail = this.statementDetail.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultOfForm('typeRadios', 'Active', 'vendorStatementMain');
    this.props.setDefaultOfForm('Days', new Date(), 'vendorStatementMain');
    //this.props.fetchCustomerStatementList('Active', formatDate(new Date()));
    this.fetchVendorStatementList('Active', moment().format('YYYY-MM-DD'));
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.vendorStatementList && nextProps.vendorStatementList !== this.props.vendorStatementList) {
      const {
        statement_lines,
        amount00_30,
        amount31_60,
        amount61_90,
        amount_91,
        current,
        grand_amount,
      } = nextProps.vendorStatementList;

      this.setState({
        rows: statement_lines,
        amount00_30: parseFloat(amount00_30).toFixed(2) || 0,
        amount31_60: parseFloat(amount31_60).toFixed(2) || 0,
        amount61_90: parseFloat(amount61_90).toFixed(2) || 0,
        amount_91: parseFloat(amount_91).toFixed(2) || 0,
        current: parseFloat(current).toFixed(2) || 0,
        grand_amount: parseFloat(grand_amount).toFixed(2) || 0,
      });
    }

    if(nextProps.typeRadios && nextProps.typeRadios != this.props.typeRadios) {
      if (this.props.Days){
        let days = moment(this.props.Days).format('YYYY-MM-DD');
        //this.props.fetchCustomerStatementList(nextProps.typeRadios, days)
        this.fetchVendorStatementList(nextProps.typeRadios, days);
      }
    }
    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      const { Days } = nextProps;
      this.setState({ Days }, this.fetchVendorStatementList);
    }
    if (!nextProps.typeRadios) {
      this.props.setDefaultOfForm('typeRadios', 'Active', 'vendorStatementMain');
    }
    if (!nextProps.Days) {
      this.props.setDefaultOfForm('Days', new Date(), 'vendorStatementMain');
    }
  }

  handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.vendorsPage });
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';

    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }

    return formattedDate;
  }

  statementDetail() {

    const currentVendor = arguments[0];
    this.props.resetCurrentVendor();
    this.props.selectVendor(currentVendor);
    this.context.router.push('/vendorStatement');

  }
    // this.context.router.push('/products/'+currentInventory.Product_id);


  // fetchCustomerStatementList() {
  //   if (this.props.Days){
  //     let days = this.formatDate(this.props.Days)
  //     this.props.fetchCustomerStatementList(this.props.typeRadios, days);
  //     }
  //   }
  fetchVendorStatementList(typeRadios = this.props.typeRadios, days = this.state.Days ? moment(this.state.Days).format('YYYY-MM-DD') : null) {
    if (days){
      if (checkPermission('vendors_manager')) {
        this.props.fetchVendorStatementList(typeRadios, days);
      } else {
        this.props.fetchVendorStatementList(typeRadios, days, this.props.selectedCompany.value);
      }
    }
  }

  renderTable() {
    if (this.props.vendorStatementListIsLoading && !this.props.vendorStatementListError) {
      return (
        <div id="spinner">
          <Spinner/>
        </div>
      );
    } else if (this.props.vendorStatementListError) {
      return (
        <div className="alert alert-danger">
          <Translate value="something_unexpected_happened" />
        </div>
      );
    } else {
        // Parameters of the react-data-grid

        let tableHeight = (window.innerHeight < 930) ? 510 : 510;

        const getRows = () => {
            return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }


        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
          this.setState(prevState => ({
            ...prevState,
            sortColumn,
            sortDirection,
          }));
        }

        const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          this.setState({ filters: newFilters });
        }
        const onClearFilters = () => {
          let rows = [...this.state.rows]
          this.setState({ rows, filters: {}, selectedRows:[], selectedIds:[]});
        };

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className='label label-danger'>-</span>;
            }
        });

        // Column difinition

        const columns = [
          {
              key: 'VendorNum',
              name: <Translate value="vendor_num" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 120,
          },
          {
              key: 'Name',
              name: <Translate value="vendor_name" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 200,
          },
          {
              key: 'Description',
              name: <Translate value="description" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 100,
          },
          /* { // Commented: 11/17/17 branch: feature/ARAP
              key: 'current',
              name: <Translate value="current" />,
              resizable: true,
              sortable: true,
              width: 80,
              formatter: PriceFormatter,
          }, */
          {
              key: 'amount00_30',
              name: <Translate value="00_dashsign_30_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          },
          {
              key: 'amount31_60',
              name: <Translate value="31_dashsign_60_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          },
          {
              key: 'amount61_90',
              name: <Translate value="61_dashsign_90_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          },
          {
              key: 'amount_91',
              name: <Translate value="91_plussign_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          },
          {
              key: 'total_amount',
              name: <Translate value="total_amount" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 100,
              formatter: CashFormatter,
          },

        ]
        let children = {};

        if (isVAK) {
          children = {
            toolbar: <Toolbar enableFilter />,
            onAddFilter: handleFilterChange,
            onClearFilters: onClearFilters,
          }
        }

        //React Table Purchase Order Full Table
        return (
          <Row>
            <Col sm={ 12 }>
              <div className='react-table-ar-ap-vendor-list-statement' id="VendorStatementMain-dataGrid1">
                <ReactDataGrid
                    {...children}
                    rowRenderer={<RowRenderer onDoubleClick={this.statementDetail} />}
                    rowKey='Deliver_Vendor_id'
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowHeight={25}
                    headerRowHeight={45}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                    minHeight={tableHeight}
                    // toolbar={<Toolbar enableFilter />}
                    // onAddFilter={handleFilterChange}
                  />
              </div>
            </Col>
          </Row>
        )
    }
  }

  renderSimplifiedExportButton() {
    const { typeRadios } = this.props;
    let { Days: date, selectedCompany } = this.props;
    date =  moment(date).endOf('day').toISOString();
    date = `PostingDate=${date}`;
    selectedCompany = `&Company_id=${selectedCompany.value}`
    if (checkPermission('vendors_manager')) {
      selectedCompany = '';
    }
    const token = localStorage.getItem('token');
    const url = `${ROOT_URL}v1/ap/report/aged/${typeRadios || 'Active'}/simplified/?${date}${selectedCompany}&Bearer=${token}`;
    return (
      <Button
        bsStyle='success'
        type='button'
        href={url}
      >
        <em className='fa fa-download' />
        <Translate value="simplified_excel" />
      </Button>
    );
  }

  renderDetailedExportButton() {
    const token = localStorage.getItem('token');
    const { typeRadios } = this.props;
    let { Days: date, selectedCompany } = this.props;
    date =  moment(date).endOf('day').toISOString();
    date = `PostingDate=${date}`;
    selectedCompany = `&Company_id=${selectedCompany.value}`
    if (checkPermission('vendors_manager')) {
      selectedCompany = '';
    }
    const exportUrl = `${ROOT_URL}v1/ap/report/aged/${typeRadios || 'Active'}/excel/?${date}${selectedCompany}&Bearer=${token}`;
    return (
      <Button
        bsStyle='success'
        className='pull-right'
        href={exportUrl}
      >
        <em className='fa fa-download' />
        <Translate value="detailed_excel" />
      </Button>
    );
  }

  render() {
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>

        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active='true'>
            <Translate value="ap_aged_report" />
          </Breadcrumb.Item>
        </Breadcrumb>

        <ButtonToolbar>
          {/*
            <Button bsStyle='primary' href={print_url} >
              <em className='fa fa-print' /><Translate value="print" />
              </Button>
          */}
          { this.renderSimplifiedExportButton() }
          { this.renderDetailedExportButton() }
        </ButtonToolbar>

        <Grid id='vendor-statement'>
          {/* <h1><Translate value="ap_aged_report" /></h1> */}
          {/* Date Range Pickers */}

            <Col xs={ 12 }>
              <Panel id='date-range-picker' className='form-horizontal'>
                <Row>
                    <Col xs={ 2 }>
                      <h3 className="text-right text-nowrap"><Translate value="statement_date" /><span classNames="colon">:</span></h3>
                    </Col>
                    <Col xs={ 10 }>
                      <div id="statusFilterRadios">
                        <ButtonToolbar className='radio-filter-buttons'>
                          <Button bsStyle='primary'>
                            <Field name='Days' placeholder={'Date'} component={DatePicker} />
                          </Button>
                          {/* <Button
                            bsStyle='primary'
                            className='search-btn'
                            type='submit'
                            onClick={() => { this.fetchVendorStatementList(); }}
                          >
                            <em className='fa fa-search' />
                          </Button> */}
                        </ButtonToolbar>
                      </div>
                  </Col>
                  <Col xs={ 2 }>
                    <h3 className="text-right text-nowrap"><Translate value="vendor_status" /><span classNames="colon">:</span></h3>
                  </Col>
                  <Col xs={ 10 }>
                    <div id="statusFilterRadios">
                      <Field name='typeRadios' component={renderVendorTypeRadios} />
                    </div>
                  </Col>
                </Row>
              </Panel>
              <Row>
                <Col xs={ 12 }>
                  <Panel className="position-relative mb0" id="table-height-fix">
                    {/* Render Inventory Table  */}
                    {this.renderTable() }
                  </Panel>
                </Col>
                <Col xs={ 12 }>
                  <Panel className="position-relative mb0">
                    {/* <Col xs={ 2 }> Commented: 11/17/17 branch: feature/ARAP
                      <label className='col-xs-6'><Translate value="current" /></label>
                      <Col xs={ 5 }>
                        <Field name='current' component={DisabledInputField} placeholder={this.state.current}/>
                      </Col>
                    </Col> */}
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="00_dashsign_30_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='amount00_30' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount00_30)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="31_dashsign_60_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='amount31_60' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount31_60)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="61_dashsign_90_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='amount61_90' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount61_90)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="91_plussign_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='amount_91' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount_91)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="grand_total" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='grand_amount' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.grand_amount)}` || 0}/>
                      </Col>
                    </Col>
                  </Panel>
                </Col>
              </Row>
            </Col>








        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML: Purchase Order List
      //---------------

    )
  }
}


export default VendorStatementMain;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/vendorStatementMain.jsx